export interface GetChatSessionDetailResponse {
  sessionId: number
  sessionOwnerTel: string
  sessionOwnerName: string
  clientName: string
  clientId: number
  serviceId: number
  sessionChannel: SessionChannelEnum
  gupShupName: string
  waPhoneNo: string
  chatHubId: string
  messageList: Message[]
  authorizedOperatorsList: AuthorizedOperatorsList[]
}

export interface Message {
  messageFrom: string
  messageDate: string
  messageContent: string
  side: MesajiGonderenTarafEnum
}

export interface AuthorizedOperatorsList {
  id: number
  name: string
  guid: string
}


export enum MesajiGonderenTarafEnum {
  Tanimsiz = 0,
  AlbinaSoft = 1,
  MusteriKurumKullanicisi = 2,
  MusteriKurumMusterisi = 3,
  User,
}

export enum SessionChannelEnum {
  Tanimsiz = 0,
  WhatsApp = 9,
  WebChat = 10,
}

